// Set up an Axios HTTP client, with interceptors for handling 401 errors (session invalid/expired)
import axios from 'axios'
import store from 'client/js/store/store.js'

const httpClient = axios.create()

// Apparently these aren't in the instance by default
httpClient.CancelToken = axios.CancelToken
httpClient.isCancel = axios.isCancel

// Set up Interceptors to handle 401 error responses.
httpClient.interceptors.response.use((res) => res, (err) => {
   console.log('HTTP Client Error', err)
  if (err && err.response.status == 401) {
    // Clear Authenticated User from our State
    store.dispatch('global/setAuthUser', {})
    setTimeout(() => {
      // Not Authenticated - redirect to Server Login URL
      window.location.assign(store.getters['global/loginUrl'])
    }, 500)
  }
  return Promise.reject(err)
})

export default httpClient
